import Vue from 'vue'
import PreviewImageComponent from './index.vue'

// 服务方式调用

// 创建子类, 返回的构造函数
// 通过extends扩展组件
const PreviewImageConstructor = Vue.extend(PreviewImageComponent)

let el = null
const previewImage = (...options) => {
  // 单例模式, 只有一个实例
  if (el) return el.previewImage(...options)

  // 要挂载的对象
  const parent = document.body

  // 通过构造函数创建组件实例, 相当于new Vue()
  const instance = new PreviewImageConstructor({
    el: document.createElement('div'), // 创建一个div元素
  })

  // 挂载到parent上
  parent.appendChild(instance.$el)
  // 显示
  Vue.nextTick(() => {
    instance.width = options?.width || 400
    instance.previewImage(...options)
  })

  // 实例赋值给
  el = instance
}

Vue.prototype.$previewImage = previewImage
